import React from "react"
import { ColorSquareProps } from "../types/color"

export const ColorSquare = (props: ColorSquareProps) => {
    return (
        <div>
            <div style={{
                backgroundColor: props.colorCode,
                width: "70px",
                height: "30px",
            }}/>
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/common/color/ColorSquare.tsx